import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { fluidType } from 'Shared/common/FluidType';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { SpaceGrotesk } from 'Shared/frontend/fonts/SpaceGrotesk';
import { INav } from 'Common/config/INav';
import { PeopleCircle } from 'Shared/backend/icons/PeopleCircle';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';


export class BotanyViewSettings extends BaseSettings
{
	palette()
	{
		return{
			background: '#ffffff',
			text: '#000000',
			feature: '#292849', //BlueishPurple
			feature2: '#c9e7ed', //LightBlue
			feature3: '#FE43A7', //Pink
			dimBackground: '#ffffff',

			/* The nav more uses feature as the background... */
			inverseText: 'white',  //XXX cf "darkThemeText" as an alternative
		};
	}

	fontIncludes()
	{
		return [
			NunitoSans,
			SpaceGrotesk,
		];
	}

	fontsText()
	{
		return({
			fontFamily: '"Nunito Sans", sans-serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,15,18),		
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Space Grotesk", serif',
			letterSpacing: 2,
			color: this.palette().feature,	
			lineHeight: 1.1,
			fontWeight: '500',
		})
	}

	//used on Teaser,Title,Tagline so they layout evenly and collapse when needed
	textMargins()
	{
		return({
			margin: '.5em 0',
		})
	}

	fonts()
	{
		return {
			text: '"Nunito Sans", sans-serif',
			heading:  '"Space Grotesk", serif',
			subNav:  '"Nunito Sans", sans-serif',
			buttons:  '"Nunito Sans", sans-serif',
			desktopNav:  '"Space Grotesk", serif',
			mobileNav:  '"Space Grotesk", serif',
		};
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				textTransform: 'uppercase',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,60),
		
			},
			title: {
				...this.fontsHeading(),
				textTransform: 'uppercase',
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,80),
			},
			plain: {
				...this.fontsText(),
			},

			teaser: {
				...this.fontsHeading(),
				...this.textMargins(),
				textTransform: 'uppercase',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),
			},
			tagline: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,20),	
				
			},

			subtitle: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,40),
				
			},
		});
	}

	//TODO BEN these might also work as a 'style' so users can select the button type they want
	button()
	{
		return({
			hollow: {
				button: {
					color: this.palette().feature,
					border: 'solid',
					borderColor: this.palette().feature,
					borderWidth: 0.5,
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
					textTransform: 'uppercase',
					backgroundColor: this.palette().background,
				},
				
			},
			filled: {
				button: {
					backgroundColor: this.palette().feature,
					color: this.palette().background,
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
					borderRadius: '0.4em',
				},
			}
		})
	}

	page()
	{
		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

		/*	header: {
				mobile: {
					display: 'flex',
					justifyContent: 'center',
					background: 'red',
				},
				logo: {
					width: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,80,150),
				}
			},

			*/

			heading: {
				color: this.palette().feature,
			},
			
			section: {},

			button: {
				backgroundColor: this.palette().feature,
				// /borderRadius: '0.4em',
				color: this.palette().background,
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,12,25),
				padding: 10,
			},

			widgets: {
				scrollStyle:{
					scrollbarColor: '#ffffff #c9e7ed !important', //#sliderColor #outerColor
				},
				overlay: {

					'.text-teaser':{
						fontWeight: '700',
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,32),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},

					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,36),
						fontWeight: '300',
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,55),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-plain': {
						//fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
				},
				subNav: {
					...this.button().hollow,
				},
			},

		});
	}

	//navigation settings
	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				type: 'standard',
				
				settings: {
					fadeBackgroundIn: false, 
					outer: {
						backgroundColor: palette.feature
					},
					
					logo:{
						padding: '10px 0px',
					},	
					button: {
						...this.fontsHeading(),
						color: palette.inverseText,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,14,30),
				
					},
				
					active: {
						color: palette.feature2,
					},


					hover: {
						color: palette.feature2,
					},

					
				}
			},

			mobile:{		
				overlay: {
					background: palette.feature
				},
		
				button:{
					color: palette.background,
					background: palette.feature,

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.background} !important`
					},

					':hover': {
			//TODO cf remove from BaseTheme?						
		//						color: this.palette().inverseText,
						backgroundColor: `hsl(from ${this.palette().feature} h calc(s + 15) calc(l + 15))`
					}
				},
				active: {
					color: palette.feature2,
					svg:{
						fill: `${palette.feature2} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.feature,
						color: palette.inverseText,
						svg: {
							fill: palette.inverseText
						},
						
					},
					button: {
						color: palette.inverseText,
						':hover': {
							color: palette.feature,
							backgroundColor: `hsl(from ${palette.background} h calc(s + 15) calc(l + 15))`
						}
					},
					address: {
						color: palette.inverseText
					},
					phone: {
						color: palette.inverseText
					},
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		//Defaults to 'General' unless uncommented and altered
		/*base.specials = {
			general: 'General',
			beers: 'Beers'
		};
		*/

// @ts-expect-error	
		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					...this.button().hollow,
				},

				heading: {
					...this.fontsHeading(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
				},
				artist: {
					heading: {
						color: palette.feature,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {

				subNav: {
					...this.button().hollow,
				},
				section: {
					h3: {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,60),
		
					},
					marginBottom: '3em'
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsHeading(),
					},
				},
			},
//probably doesn't do anything
			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}


	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Bistro',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'},
		//		{label:'Book',		link:'frontend/Book'},
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				//Todo Ben Nav MORE button doesn't launch on mobile frontend since 
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Bistro',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
		//			{label:'Book',		link:'frontend/Stay', 	icon:PeopleCircle},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:PeopleCircle},
		];
	}


	//todo Ben setup routes for the minor pages above see TownieSettings for a template to adapt?
	
}

